import { Keys, Values } from "@pdfking/tfunc"
// Function to transform and evaluate the string
export default function renderString(
  template: string,
  obj: Record<string, any> = {}
): string {
  // Create a function that returns the evaluated string as a template literal
  const func = new Function(...Keys(obj), `return \`${template}\`;`)

  // Pass the values of the object to the function and return the result
  return func(...Values(obj))
}
